import styled from 'styled-components';

// 텍스트 인풋 타입1
// height: 34px | font-size: 14px
export const TextInputType1 = styled.input`
  background-color: #fff;
  display: block;
  height: 34px;
  border-radius: 4px;
  border: 1px solid ${(props) => props.theme.inputBorderColor};
  box-sizing: border-box;
  padding: 0 18px;
  font-size: 14px;
  color: ${(props) => props.theme.inputColor};
  &::placeholder {
    color: ${(props) => props.theme.inputPlaceholderColor};
  }
  &:disabled {
    background-color: ${(props) => props.theme.inputDefaultBackgroundColor};
    color: ${(props) => props.theme.inputDefaultColor};
  }
`;
// height: 36px | font-size: 12px
export const TextInputType1mini = styled(TextInputType1)`
  height: 36px;
  font-size: 12px;
`;

// 파일 인풋 타입1
// font-size: 14px
export const FileTextType1 = styled.div`
  > span {
    font-size: 14px;
  }
  > span.no-file-text {
    color: #999;
  }
  > span.file-text {
    color: #555555;
  }
  display: flex;
  align-items: center;
  gap: 8px;
  > button {
    width: 10px;
  }
`;

// 텍스트 영역 타입1
// font-size: 14px
export const TextAreaType1 = styled.textarea`
  background-color: #fff;
  display: block;
  width: 100%;
  border-radius: 8px;
  border: 1px solid ${(props) => props.theme.inputBorderColor};
  box-sizing: border-box;
  padding: 12px 16px;
  font-size: 14px;
  color: ${(props) => props.theme.inputColor};
  &::placeholder {
    color: ${(props) => props.theme.inputPlaceholderColor};
  }
`;

// 셀렉트 타입1
// height: 48px | font-size: 14px
export const SelectType1 = styled.div`
  height: 34px;
  position: relative;
  > select {
    background-color: #fff;
    display: block;
    width: 100%;
    height: 100%;
    border-radius: 4px;
    border: 1px solid ${(props) => props.theme.inputBorderColor};
    box-sizing: border-box;
    padding: 0 32px 0 18px;
    font-size: 14px;
    color: ${(props) => props.theme.inputPlaceholderColor};
    &.selected {
      color: ${(props) => props.theme.inputColor};
    }
    &:disabled {
      background-color: ${(props) => props.theme.inputDefaultBackgroundColor};
      color: ${(props) => props.theme.inputDefaultColor};
    }
  }
  > .img-box {
    width: 9px;
    right: 18px;
    top: 50%;
    transform: translateY(-50%);
    position: absolute;
    pointer-events: none;
  }
`;

// 체크 박스 타입1
// 네모
export const CheckBoxType1 = styled.div`
  width: 16px;
  height: 16px;
  display: inline-block;
  input {
    display: none;
  }
  label {
    cursor: pointer;
    width: 100%;
    display: block;
  }
  input:checked + label > img {
    content: url(/img/ico_check_1_active.svg);
  }
  input:disabled + label > img {
    content: url(/img/ico_check_1_disabled.svg);
  }
`;

// 체크 박스 타입2
// 원형
export const CheckBoxType2 = styled.div`
  width: 15px;
  height: 15px;
  display: inline-block;
  input {
    display: none;
  }
  label {
    cursor: pointer;
    width: 100%;
    display: block;
  }
  input:checked + label > img {
    content: url(/img/ico_check_3_active.svg);
  }
`;

// 체크 텍스트 박스 타입1
// 네모
export const CheckTextBoxType1 = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  .opne-state {
    width: 11px;
  }
  .check-box {
    input {
      display: none;
    }
    label {
      cursor: pointer;
      width: 100%;
      display: flex;
      align-items: center;
      gap: 6px;
      > .img-box {
        width: 15px;
      }
      > .text {
        font-size: 14px;
        font-weight: 500;
        color: #222;
        &.text-2 {
          color: #777;
          font-weight: 400;
        }
      }
    }
    input:checked + label > .img-box > img {
      content: url(/img/ico_check_2_active.svg);
    }
  }
`;

// 체크 텍스트 박스 타입2
// 원형
export const CheckTextBoxType2 = styled.div`
  > input {
    display: none;
  }
  > label {
    cursor: pointer;
    display: inline-flex;
    align-items: center;
    gap: 12px;
    > .img-box {
      width: 15px;
    }
    > .text {
      font-size: 14px;
      color: #555;
    }
  }
  > input:checked + label > .img-box > img {
    content: url(/img/ico_check_3_active.svg);
  }
`;

// 컨트롤 박스
export const CtrlBox = styled.div`
  display: inline-block;
  > input {
    display: none;
  }
  > input:checked + label {
    background-color: #437be6;
    &::after {
      right: 2px;
    }
  }
  > label {
    display: block;
    width: 32px;
    height: 19px;
    background-color: #adb3b7;
    border-radius: 15px;
    cursor: pointer;
    position: relative;
    &::after {
      content: '';
      display: block;
      width: 15px;
      height: 15px;
      border-radius: 50%;
      background: #fff;
      position: absolute;
      top: 50%;
      right: 15px;
      transform: translateY(-50%);
    }
  }
`;

const IS = {
  TextInputType1,
  TextInputType1mini,
  FileTextType1,
  TextAreaType1,
  SelectType1,
  CheckBoxType1,
  CheckBoxType2,
  CheckTextBoxType1,
  CheckTextBoxType2,
  CtrlBox,
};

export default IS;
